var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheveron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.13477,
    width: 3,
    height: 8,
    transform: "rotate(-45 0 2.13477)",
    fill: "#FFECD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.40088,
    y: 7.07104,
    width: 3,
    height: 7,
    transform: "rotate(-135 6.40088 7.07104)",
    fill: "#FFECD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheveron);
export default __webpack_public_path__ + "static/media/Cheveron.cb7063d567d44a1378d2974a6f212f1c.svg";
export { ForwardRef as ReactComponent };